import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-186bac56"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar" }
const _hoisted_2 = { class: "logo" }
const _hoisted_3 = { href: "/" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "mob-content-bar" }
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/_createTextVNode("首页")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("主营业务")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("产品优势")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("联系我们")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_content_bar = _resolveComponent("content-bar")!
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_scroll_to = _resolveDirective("scroll-to")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", _hoisted_3, [
        _createElementVNode("img", {
          src: _ctx.logo,
          alt: "log"
        }, null, 8, _hoisted_4)
      ])
    ]),
    _createVNode(_component_content_bar),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("img", {
        src: _ctx.mobBar,
        alt: "",
        class: "mob-bar",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.mobBarClick && _ctx.mobBarClick(...args)))
      }, null, 8, _hoisted_6)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["mob-content", [_ctx.showMobContent && 'show']])
    }, [
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          _hoisted_7
        ]),
        _: 1
      }),
      _withDirectives(_createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          _hoisted_8
        ]),
        _: 1
      }, 512), [
        [_directive_scroll_to, '#business']
      ]),
      _withDirectives(_createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          _hoisted_9
        ]),
        _: 1
      }, 512), [
        [_directive_scroll_to, '#product']
      ]),
      _createVNode(_component_router_link, { to: "/contact-us" }, {
        default: _withCtx(() => [
          _hoisted_10
        ]),
        _: 1
      })
    ], 2)
  ]))
}